import { render, staticRenderFns } from "./ScheduledCallView.vue?vue&type=template&id=65373c35&"
import script from "./ScheduledCallView.vue?vue&type=script&lang=js&"
export * from "./ScheduledCallView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports